import { Box, Typography, Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom"; // за навигация без презареждане

const EmptyCart = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        textAlign: "center",
        backgroundColor: "#eaf0f8",
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          fontWeight="bold"
          mb={2}
          sx={{ color: "#2f4f7f" }}
        >
          Количката е празна 🛒
        </Typography>
        <Typography variant="body1" mb={4} sx={{ color: "#4a5f7a" }}>
          Изглежда сте изчистили всичко!
        </Typography>
        <Typography variant="body1" mb={4} sx={{ color: "#4a5f7a" }}>
          Напълнете я с професионалните препарати предлагани от{" "}
          <strong>Ти Си Енерджи ЕООД</strong> и открийте как почистването може
          да бъде лесно и ефективно.
        </Typography>
        <Button
          variant="contained"
          size="medium"
          sx={{
            backgroundColor: "#2f4f7f",
            color: "#f2d35c",
            fontWeight: "bold",
            px: 5,
            py: 1.5,
            "&:hover": { backgroundColor: "#1f3558", transform: "scale(1.05)" },
            transition: "0.2s",
          }}
          onClick={() => navigate("/agents")} // навигация без презареждане
        >
          Разгледайте всички препарати
        </Button>
      </Container>
    </Box>
  );
};

export default EmptyCart;
